import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, inject, computed } from "vue";
  import axios from "axios";

  
export default {
  __name: 'DeleteEntries',
  props: {
    entries: {
      type: Array,
      required: true,
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(__props) {

  const permissions = inject("permissions");
  const deleteUrl = inject("deleteUrl");

  const props = __props;

  const modalId = `delete-modal-${Math.random().toString(36).slice(2, 9)}`;
  const selectedOption = ref("previous");
  const showSelect = computed(
    () => props.entries[0].validFrom && new Date(props.entries[0].validFrom?.date) <= new Date()
  );

  const handleDelete = async (event) => {
    event.preventDefault();
    try {
      const payload = {
        entryIds: props.entries.map((entry) => entry.id),
        ...(props.showSelect && { applyOption: selectedOption.value }),
      };

      await axios.delete(deleteUrl, { data: payload });
      window.location.reload();
    } catch (error) {
      console.error("Failed to delete opening hours:", error);
    }
  };

return (_ctx, _cache) => {
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_form_radio = _resolveComponent("b-form-radio")
  const _component_b_form_group = _resolveComponent("b-form-group")
  const _component_b_modal = _resolveComponent("b-modal")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(permissions).canDelete)
      ? _withDirectives((_openBlock(), _createBlock(_component_b_button, {
          key: 0,
          size: "sm",
          variant: "outline-danger"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })), [
          [_directive_b_modal, modalId]
        ])
      : _createCommentVNode("v-if", true),
    _createVNode(_component_b_modal, {
      id: modalId,
      title: "Öffnungszeiten löschen",
      "ok-title": "Löschen",
      "cancel-title": "Abbrechen",
      onOk: handleDelete
    }, {
      default: _withCtx(() => [
        (showSelect.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "Welche Öffnungszeiten sollen nach dem Löschen gelten?", -1 /* CACHED */)),
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_radio, {
                    modelValue: selectedOption.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedOption).value = $event)),
                    name: "delete-option",
                    value: "previous"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Vorherige Öffnungszeiten verwenden ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"]),
                  _createVNode(_component_b_form_radio, {
                    modelValue: selectedOption.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedOption).value = $event)),
                    name: "delete-option",
                    value: "next"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Nachfolgende Öffnungszeiten verwenden ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_2, " Diese Öffnungszeiten löschen? "))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}